import React from 'react';
import './index.scss';
import {
  formatTextFloat,
  formatPercent,
  formatPrice,
  formatChange,
} from '../../../helpers/Text';
import TextBlinkCustom from '../../../common/text-blink-custom';
import {
  getColorPrice,
  getIconPriceFollowReferencePrice,
} from './../../../helpers/Color';

function renderContent(
  MatchPrice,
  PriceChange,
  PercentPriceChange,
  ReferencePrice,
  CeilingPrice,
  FloorPrice,
  isDerivatives,
  isIndex,
) {
  const matchPrice = !isNaN(MatchPrice / 1000)
    ? (isDerivatives || isIndex ? MatchPrice : formatPrice(MatchPrice))
        .toFixed(2)
        .toString()
        .split('.')
    : ['--', '--'];

  const priceChangeCalculated = !isNaN(PriceChange / 1000)
    ? isDerivatives || isIndex
      ? formatChange(formatTextFloat(PriceChange, 2))
      : formatChange(formatTextFloat(formatPrice(PriceChange), 2))
    : '--';

  const classNameColor =
    CeilingPrice === 0 || FloorPrice === 0
      ? getColorPrice(MatchPrice, ReferencePrice)
      : getColorPrice(MatchPrice, ReferencePrice, CeilingPrice, FloorPrice);
  const classNameIcon = getIconPriceFollowReferencePrice(
    MatchPrice,
    ReferencePrice,
  );

  return (
    <div className={`summary-info-wrapper-price`}>
      <div className="left-container">
        <div className={`main-price ${classNameColor}`}>
          {formatTextFloat(parseFloat(`${matchPrice[0]}`), 0)}
        </div>
        <div className="d-flex flex-column justify-content-center">
          <div className={`sub-price ${classNameColor}`}>
            {`.${matchPrice[1] || '00'}`}
          </div>
          <div className="currency">VND</div>
        </div>
      </div>
      <div className="right-container d-flex flex-column">
        <div className={`sub-price ${classNameColor}`}>
          {priceChangeCalculated}
        </div>
        <div className="percent d-flex">
          <i className={`${classNameColor} ${classNameIcon} fs-10 mr-1`} />
          {`${formatTextFloat(formatPercent(PercentPriceChange))}%`}
        </div>
      </div>
    </div>
  );
}

class indexSummary extends React.Component {
  render() {
    const {
      data: {
        MatchPrice,
        PriceChange,
        PercentPriceChange,
        ReferencePrice,
        CeilingPrice = null,
        FloorPrice = null,
      },
      isDerivatives = false,
      keyToCompare,
      isIndex = false,
    } = this.props;

    const priceContent =
      parseFloat(MatchPrice) > 0
        ? renderContent(
            MatchPrice,
            PriceChange,
            PercentPriceChange,
            ReferencePrice,
            CeilingPrice,
            FloorPrice,
            isDerivatives,
            isIndex,
          )
        : renderContent('--.--', '--', '--', '--', '--', '--', false, false);

    return (
      <TextBlinkCustom compareKey={keyToCompare} data={this.props.data}>
        {priceContent}
      </TextBlinkCustom>
    );
  }
}

indexSummary.defaultProps = {
  data: {
    MatchPrice: 0,
    PriceChange: 0,
    PercentPriceChange: 0,
    ReferencePrice: 0,
    CeilingPrice: null,
    FloorPrice: null,
  },
  isDerivatives: false,
  keyToCompare: 'tradingDate',
  isIndex: false,
};

export default indexSummary;
